import styled from 'styled-components';
import { CardGrid } from 'component-library';

const Grid = styled(CardGrid)`
  padding: 2.5rem 3rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
`;

export { Grid };
